import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";

import Ktg_New from "./ktg_new";
import Ktg_Open from "./ktg_open";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Kt extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.ktga = [];
    this.state.kro = {};
    this.state.aa = [];
    this.state.cols = {};
    this.state.wnds = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.ktg();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  ktg_new() {
    var self = this;
    var wnds = {};
    wnds.ktgnew = true;
    this.setState({ wnds: wnds });
  }
  ktg_open(row) {
    var self = this;
    var wnds = {};
    wnds.ktgopen = true;
    wnds.kto = row;
    this.setState({ wnds: wnds });
  }

  ktg() {
    var self = this;
    var prm = {};
    prm.req = "pms.kt.kt_grp";
    prm.fdat = "20200915";
    prm.tdat = "20200915";
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ktga: ret.rco }, function () {
            self.syncCols("ktgTable");
        });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  cssCols = function (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols = function (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };

  render() {
    return (
    <div className="web-app">
    <div className="flex-row flex-space-between">
        <div className="flex-row flex">
        <button className="btn btn-hw-blue w150" onClick={() => this.ktg_new() } aria-label="System" >
            LÄGG TILL
        </button>
        </div>
        <div className="flex-row">
       </div>
        <div className="flex-row flex-end flex">
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            UPPDATERA
        </button>
        </div>
    </div>
    <div className="divider_orange"></div>

    <div className="web-col">
        <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th style={ this.cssCols("c01" ) }>Typ</th>
                <th style={ this.cssCols("c02" ) }>Text</th>
                <th style={ this.cssCols("c03" ) }>Bokstav</th>
                <th style={ this.cssCols("c04" ) }></th>
                <th style={{width:"16px"}} ></th>
            </tr>
            </thead>
        </table>
       <div className="tb-cdi" style={ this.tb_style() }>
       <table id="ktgTable" className="table table-bordered table-hover tb">
            <tbody>
            { this.state.ktga.map((row, key) =>
            <tr key={key} id={ row.r0typ } onDoubleClick={() => this.ktg_open(row) }>
                <td>{ row.r0typ }</td>
                <td>{ row.r0text }</td>
                <td>{ row.r0bokstav }</td>
                <td style={{width:"40px",cursor:"pointer"}} onClick={() => this.ktg_open(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            <tr style={{visibility: "hidden"}}>
				<th>Typ</th>
				<th>Text</th>
				<th>Bokstav</th>
                <th></th>
            </tr>
            </tbody>
        </table>
        </div>
    </div>
        { this.state.wnds.ktgnew ? <Ktg_New wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.ktgopen ? <Ktg_Open wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
   </div>
  );
    }
}
export default Reg_Kt;
